export default {
  mensual: 1,
  diario: 0,
}